/** @format */

import Theme1 from "../assets/images/theme1.png";
import Theme2 from "../assets/images/theme2.png";
import Theme3 from "../assets/images/theme3.png";
import Card1 from "../assets/images/card1.png";
import Card2 from "../assets/images/card2.png";
import { indigo } from "@mui/material/colors";

const darkPalette = {
  primary: {
    // main: "#184880",
    main: "#f07b47",
  },
  secondary: {
    // main: "#8B2C2C ",
    main: indigo[700],
    // main: "#00bda6",
    // main: "#f8c507",
  },
  mode: "dark",
};

const lightPalette = {
  primary: {
    // main: "#184880",
    main: indigo[800],
  },
  secondary: {
    main: "#446285",
  },
  mode: "light",
};

const shapeProperties = {
  borderRadius: 2,
};

const websiteThemes = [
  {
    image: Theme1,
    theme: 1,
  },
  {
    image: Theme2,
    theme: 2,
  },
  {
    image: Theme3,
    theme: 3,
  },
];

const idCardThemes = [
  {
    image: Card1,
    theme: 1,
  },
  {
    image: Card2,
    theme: 2,
  },
];

export default {
  lightPalette,
  darkPalette,
  shapeProperties,
  websiteThemes,
  idCardThemes,
};
